jQuery(document).ready(function($) {

  // Update timestamp on user

  $('#input_3_46').val(Math.floor(Date.now() / 1000));

  // Get Window Width and Height
  var windowWidth = $(window).outerWidth();
  var windowHeight = $(window).height();

  /* Document ready functions */
  $(document).ready(function (){

    // Set Fullscreen image
    $('.section-full-height').css({"height":windowHeight -61});

    // Set Fullscreen Scroll down
    $('.section-full-height').append('<i class="scrolldown fi flaticon-nav-arrow-down"></i>');
    $(".scrolldown").each(function(){
      $(this).on("click", function() {
        $('html,body').animate({scrollTop: $(this).parent().next().offset().top -60}, 500);
      });
    });

    $('.mobile-menu-button').on('click',function(){
      $('body').toggleClass('navOpen');
      $(".header-search").removeClass("visible");
    });


    // {$('.profilePic').on('mouseenter', function(){
    // 	$('.userSettings').addClass('visible');
    // 	setTimeout(function () {
    // 		$('.userSettings').removeClass('visible');
    // 	}, 5500);
    // });}

    // Show and hide job items
    function close_job_section() {
      $('.job-itemWrp .fa').removeClass('active');
      $('.job-itemWrp .fa').nextAll('.job-item').slideUp(300).removeClass('open');
    }
    $('.job-itemWrp .fa').click(function() {
      if($(this).hasClass('active')) {
        close_job_section();
      }else {
        $('.job-itemWrp .fa').nextAll('.job-item').slideUp(300).removeClass('open');
        close_job_section();
        // Add active class to section title
        $(this).addClass('active');
        // Open up the hidden content panel
        $(this).nextAll('.job-item').slideDown(300).addClass('open');
      }
    });

  });


  if( windowWidth <= 1023 ) {
    var navbarHeight = $('#site-header').outerHeight();
    $( '#pageWrp' ).css('padding-top', navbarHeight)
  }

  $(window).resize(function () {

    // Get Window Width and Height on resize
    windowWidth = $(window).outerWidth();
    windowHeight = $(window).height();

    // Set Fullscreen image
    $('.section-full-height').css({"height":windowHeight -61});

  });

  var messageCount = $('.countDiv').attr('data-count');
  if(messageCount == 0) {
    var messageTxt = 'inga nya händelser';
  } else if(messageCount == 1) {
    var messageTxt = '1 ny händelse';
  } else {
    var messageTxt = messageCount + 'nya händelser';
  }

  $('.count').text(messageTxt);


  $(".chosen-select").chosen({max_selected_options: 5, width: "95%"});

  $(".chosen-select").on('change', function(){
    $('.facilityArr').val($(this).val());
  });

});

// jQuery(document).ready(function onMiscReady($) {
//     "use strict";

//     flatpickr(".datepicker", {
//         altFormat: "F j, Y"
//     });
// });
